import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M4.848 4.102a.75.75 0 0 1 .613.393C6.35 6.149 7.89 7.657 9.557 8.35c.202-1.068.678-2.016 1.395-2.75.934-.953 2.235-1.5 3.748-1.5 1 0 1.843.191 2.555.571.585.313 1.05.735 1.431 1.23H21a.75.75 0 0 1 .624 1.165L19.95 9.58c-.043 3.194-.982 5.999-2.774 8.03C15.33 19.7 12.64 20.9 9.3 20.9c-1.945 0-3.359-.512-4.462-1.292-1.075-.76-1.812-1.75-2.435-2.603a.75.75 0 0 1 .394-1.177l.008-.003.085-.027a142 142 0 0 0 1.233-.411l.271-.09C1.876 12.043 1.865 7.66 4.19 4.413a.75.75 0 0 1 .658-.312",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }